// Shared "back to <somewhere>" link, placed above the breadcrumb on sub-pages.
// Uses React Router navigate under the hood. Icon + label; keyboard focusable.

import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

interface BackLinkProps {
  to: string;
  label: string;
  className?: string;
}

export default function BackLink({ to, label, className = "" }: BackLinkProps) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(to)}
      className={`inline-flex items-center gap-1 text-ink2 text-[12.5px] font-semibold bg-transparent border-none cursor-pointer px-2 py-1 -ml-2 rounded-md hover:bg-[#EEF4FB] hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-dark ${className}`}
    >
      <ChevronLeft size={16} strokeWidth={2.25} aria-hidden="true" />
      <span>{label}</span>
    </button>
  );
}